import { useEffect } from 'react';
import useDeviceSizeStore from '../../store/deviceSize';
import getDeviceBreakpoint from '../../../common-utils/functions/getDeviceBreakpoint';

/**
 * Set the device size store
 * @param {Function} storeDeviceSize Store function to set device size
 * @returns {void}
 */
const handleResize = (storeDeviceSize) => {
    const breakpoint = getDeviceBreakpoint(window.innerWidth);
    storeDeviceSize(breakpoint);
};

/**
 * A hook to listen to window resize event and uppate device size store
 * @returns {void}
 */
const useDeviceType = () => {
    // Store
    const storeDeviceSize = useDeviceSizeStore(s => s.storeDeviceSize);

    // Hook
    useEffect(() => {
        // Set isSmallDevice on each rendering
        handleResize(storeDeviceSize);
        // Listen to window resize event to set device size
        window.addEventListener('resize', () => handleResize(storeDeviceSize));

        // Remove event listener on clean up
        return () => {
            window.removeEventListener('resize', () => handleResize(storeDeviceSize));
        };
    }, []);
};

export default useDeviceType;